module.exports = __webpack_public_path__ + "static/media/W_Calendar_04.e043fa1c.png";